import { render, staticRenderFns } from "./BackerCenterLayout.vue?vue&type=template&id=f4eee4fe"
import script from "./BackerCenterLayout.vue?vue&type=script&lang=js"
export * from "./BackerCenterLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports